import { ArrowLeft } from "lucide-react";

import { Brand } from "../components/Brand";

const content = {
  terms: {
    title: "Conditions d'utilisation",
    sections: [
      ["Nature du service", "Vox est un service tiers independant qui fournit un transport vocal externe a certaines experiences. Vox n'est ni affilie, ni approuve, ni exploite par Roblox Corporation."],
      ["Acces", "L'acces peut etre limite a des tests prives, des invitations ou des univers autorises. Toute tentative d'usurpation, d'abus du service ou de contournement de ses protections peut entrainer une suspension."],
      ["Responsabilite des studios", "Chaque studio client reste responsable de son experience, de sa moderation et de l'information fournie a ses joueurs."],
    ],
  },
  privacy: {
    title: "Confidentialite et donnees",
    sections: [
      ["Donnees traitees", "Pour rendre la voix spatiale, Vox traite temporairement l'identite Roblox verifiee, la salle, les positions courantes, l'orientation, le mode vocal et des coefficients acoustiques."],
      ["Audio", "Le son est transporte en temps reel par WebRTC. Aucun enregistrement, aucune transcription, aucune reconnaissance vocale et aucun profil vocal ne sont realises par defaut."],
      ["Conservation", "Les positions et orientations restent en memoire et expirent avec la salle. Les donnees de compte, licence, usage agrege, audit et signalement suivent les durees documentees par le service."],
      ["Vos choix", "Vous pouvez couper votre micro, assourdir la salle, bloquer un participant et signaler un abus. Une demande d'acces ou de suppression peut etre adressee au contact du service."],
    ],
  },
  moderation: {
    title: "Politique de moderation",
    sections: [
      ["Protection immediate", "Chaque participant peut rendre une personne muette localement, la bloquer et transmettre un signalement a l'equipe responsable de l'experience."],
      ["Mesures", "Selon les faits et les regles applicables, un utilisateur peut etre exclu d'une salle, banni du vocal d'une experience ou banni d'une licence."],
      ["Signalements", "Les signalements doivent decrire des faits precis. Vox conserve les metadonnees necessaires a leur traitement, mais aucun extrait audio n'est joint automatiquement."],
    ],
  },
} as const;

export function LegalPage({ page }: { page: keyof typeof content }) {
  const document = content[page];
  return (
    <div className="legal-page">
      <header className="public-header">
        <Brand />
        <a className="icon-label-button" href="/">
          <ArrowLeft size={15} /> Retour
        </a>
      </header>
      <main>
        <p className="eyebrow">Vox · Informations legales</p>
        <h1>{document.title}</h1>
        <p className="legal-date">Version de travail pour le staging prive.</p>
        {document.sections.map(([title, body]) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{body}</p>
          </section>
        ))}
        <section>
          <h2>Contact</h2>
          <p>
            Les coordonnees definitives de support et de protection des donnees
            doivent etre renseignees avant toute ouverture publique.
          </p>
        </section>
      </main>
    </div>
  );
}
